import React, { Component } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FormRenovacaoAporte from './formRenovacaoAporte'
import FormRenovacaoResgate from './formRenovacaoResgate'
import FormResgateTotal from './formResgateTotal'
import FormRenovacaoTotal from './formRenovacaoTotal'

import './modalRenovacao.css'

class ModalRenovacao extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: null,
            message: '',
            success: false,
            tipoContrato: props.contrato.tipoContrato,
            idContrato: props.contrato.id,
            file: null,
            contrato: props.contrato,
            userId: props.userid,
            tipoOperacao: props.tipoOperacao,
            closeModal: props.closeModal,
            uploadError: props.uploadError,
            uploadSuccess: props.uploadSuccess
        }
    }


    componentWillMount() {
        if (this.interval) {
            clearTimeout(this.interval)
        }
    }

    renderElement() {
        if (this.state.tipoOperacao === 'RenovacaoAporte') {
            return (
                <Row>
                    <Col>
                        <FormRenovacaoAporte uploadError={this.state.uploadError} uploadSuccess={this.uploadSuccess} userId={this.state.userId} tipo={this.state.tipoContrato} idContrato={this.state.idContrato} closeModal={this.state.closeModal} contrato={this.props.contrato}/>
                    </Col>
                </Row>
            )
        } else if (this.state.tipoOperacao === 'RenovacaoResgate') {
            return (
                <Row>
                    <Col>
                        <FormRenovacaoResgate userId={this.state.userId} tipo={this.state.tipoContrato} idContrato={this.state.idContrato} closeModal={this.state.closeModal} contrato={this.props.contrato}/>
                    </Col>
                </Row>
            )
        } else if (this.state.tipoOperacao === 'RenovacaoTotal') {
            return (
                <Row>
                    <Col>
                        <FormRenovacaoTotal userId={this.state.userId} tipo={this.state.tipoContrato} idContrato={this.state.idContrato} closeModal={this.state.closeModal} contrato={this.props.contrato} />
                    </Col>
                </Row>
            )
        } else if (this.state.tipoOperacao === 'ResgateTotal') {
            return (
                <Row>
                    <Col>
                        <FormResgateTotal userId={this.state.userId} tipo={this.state.tipoContrato} idContrato={this.state.idContrato} closeModal={this.state.closeModal} contrato={this.props.contrato} />
                    </Col>
                </Row>
            )
        }
    }


    render() 
    {
        return (
            <div className="animated fadeIn">
                {this.renderElement()} 
            </div>
        )
    }
}

export default ModalRenovacao